import React from "react";

function DashbordRightCard({ data }) {
  return (
    <main className="mb-4 bg-white ">
      <section className=" rounded-md p-[24px]">
        <div className="text-[#98A2B3] text-[14px] font-[700] mt-1 ">
          {data.title}
        </div>
        <div className="mt-[46px] ">
          {data?.rows?.map((item, index) => (
            <div
              key={index}
              className={`flex justify-between text-[12px] font-[400] ${
                index !== data.rows.length - 1 ? " pb-[44px]" : "0"
              }`}
            >
              <p>{item.title}</p>
              <p>{item.count}</p>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}

export default DashbordRightCard;
